import SingleOrderDetail from './SingleOrderDetail.styled';

export default SingleOrderDetail;
